import { render } from "./home-profile.vue?vue&type=template&id=66706ba6&scoped=true"
import script from "./home-profile.vue?vue&type=script&lang=js"
export * from "./home-profile.vue?vue&type=script&lang=js"

import "./home-profile.vue?vue&type=style&index=0&id=66706ba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66706ba6"]])

export default __exports__